import { n as e } from "./PortalContainerContext-Cz7eWR3N.js";
import { i as t, n, r, t as i, u as a } from "./useVoiceUpload-DQm1wDbu.js";
import { t as o } from "./useFlxFillHeight-qOgJEo-e.js";
import { CHAT_FAB_NOTIFICATION_CLEAR_DELAY_MS as s, ChatDisplayType as c, ChatMessageType as l, ComponentIdentifierEnum as u, activeChatSessionIdStore as d, buildAttachmentsMessagePayload as f, buildMessageTimeGroupLabels as p, chatStore as m, clearConversationsSearch as h, computeChatFabNotificationCount as g, config as _, conversationsListPaginationStore as v, conversationsSearchStore as y, detachChat as b, fetchDocument as x, formatDateWithAppSettings as S, formatMessageTimestamp as C, getActiveChatSessionId as w, getLastAgentSuggestions as T, getStaticAssetByKey as E, getUiFlowType as D, getUrlQueryParamValue as ee, groupSessionsByDate as te, initChat as ne, initChatSession as O, loadChatSessionHistory as k, loadConversationsList as re, loadMoreConversations as A, localizeString as j, localizeTemplateText as M, mapConversationsToSearchSessions as ie, markChatFabSeen as ae, normalizeSuggestedPrompts as oe, partMarker as N, requestConversationsSearch as se, resolveChatSessionId as ce, resolveMessageActionsConfig as le, resolveMessageTimestamp as ue, setActiveChatSessionId as de, showToast as fe, uiFlowType$ as pe, updateUrlWithQueryParam as P, uploadChatFilesAndWait as me } from "@flowx/core-sdk";
import { createContext as he, useCallback as F, useContext as I, useEffect as L, useMemo as R, useRef as z, useState as B } from "react";
import { useObservableState as ge, useSubscription as V } from "observable-hooks";
import { clsx as H } from "clsx";
import { EMPTY as _e, combineLatest as ve, map as ye } from "rxjs";
import { ThemeComponent as U, applyChatAgentMessageCustomStyles as be, applyChatErrorMessageCustomStyles as xe, applyChatFileAttachmentsCustomStyles as Se, applyChatFileItemCustomStyles as Ce, applyChatHeaderCustomStyles as we, applyChatHistoryCustomStyles as Te, applyChatInputCustomStyles as Ee, applyChatMessagesCustomStyles as De, applyChatSuggestedPromptsCustomStyles as Oe, applyChatUserAttachedFilesCustomStyles as ke, applyChatUserFileItemCustomStyles as Ae, applyChatUserMessageCustomStyles as je, applyChatUserVoiceMessageCustomStyles as Me, applyChatVoiceInputCustomStyles as W, applyWrapperStyles as Ne } from "@flowx/core-theme";
import { getIconAsset as G, getThemingClassName as K, useCustomStyles as q, usePositionStyles as Pe } from "@flowx/react-theme";
import { FlxChat as Fe, FlxChatHeader as Ie, FlxChatHistory as Le, FlxChatHistoryItem as Re, FlxChatHistorySection as ze, FlxChatInput as Be, FlxChatMessage as Ve, FlxChatMessageActions as He, FlxChatMessageFeedback as Ue, FlxChatMessages as We, FlxChatReasoning as Ge, FlxChatSuggestedPrompts as Ke, FlxIcon as qe, getFileExtension as Je } from "@flowx/react-ui-toolkit";
import { Fragment as Ye, jsx as J, jsxs as Xe } from "react/jsx-runtime";
import { isEqual as Ze } from "lodash";
import { Popover as Y } from "@base-ui/react/popover";
import './FlxChatWrapper.css';//#region \0rolldown/runtime.js
var Qe = Object.create, $e = Object.defineProperty, et = Object.getOwnPropertyDescriptor, tt = Object.getOwnPropertyNames, X = Object.getPrototypeOf, nt = Object.prototype.hasOwnProperty, rt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), it = (e, t) => {
	let n = {};
	for (var r in e) $e(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || $e(n, Symbol.toStringTag, { value: "Module" }), n;
}, at = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = tt(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !nt.call(e, s) && s !== n && $e(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = et(t, s)) || r.enumerable
	});
	return e;
}, ot = (e, t, n) => (n = e == null ? {} : Qe(X(e)), at(t || !e || !e.__esModule || !nt.call(e, "default") ? $e(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), st = (e) => {
	let [t, n] = B(""), [r, i] = B({
		query: "",
		sessions: [],
		loading: !1
	}), a = F((t) => {
		n(t), se(e, t);
	}, [e]);
	L(() => () => h(), []);
	let o = R(() => ve([y.stream$, d.stream$]).pipe(ye(([e, t]) => ({
		search: e,
		currentId: t
	}))), []);
	return V(o, ({ search: e, currentId: t }) => {
		i({
			query: e.query,
			sessions: ie(e.results, t),
			loading: e.loading
		});
	}), {
		searchText: t,
		onSearchChange: a,
		clearSearch: F(() => {
			n(""), h();
		}, []),
		isSearchActive: r.query.length > 0,
		appliedQuery: r.query,
		searchSessions: r.sessions,
		searchLoading: r.loading
	};
}, ct = he(null), lt = () => I(ct), ut = async (e) => x(e), dt = ({ messages: t, reasoning: n, showSuggestedPrompts: r, agentSuggestions: i, config: a, avatars: o, icons: s, onSendMessage: c, onSendSuggestedPrompt: u, onSendConfiguredPrompt: d, onMessageCopied: f, onNewChat: p, headerControls: m, sendAriaLabel: h, sendTooltip: g, stopAriaLabel: v, stopTooltip: y, voiceMicAriaLabel: b, onToggleFullscreen: x, isFullscreen: w, showFullscreenToggle: T, onClose: E, displayMode: D, showHeaderAvatar: ee, hideHeader: ne = !1, headerActionIcons: O, activeView: k = "chat", onHistory: re, onBackFromHistory: A, chatSessions: j, onSelectSession: M, onLoadMoreSessions: ie, hasMoreSessions: ae, loadingMoreSessions: oe, emptyStateText: N, searchValue: se, onSearchChange: ce, onSearchClear: le, searchPlaceholder: ue, searchClearAriaLabel: de, searchHighlightText: fe, sessionGroupLabels: pe, headerTooltips: P, hasMoreMessages: me, loadingMore: he, onLoadMore: F, classNames: I, onVoiceMessage: L, showVoiceInput: z, voiceLabels: B, onStopResponse: ge, inputDisabled: V = !1, inputDisabledTooltip: _e, showFileUpload: ve, fileAccept: ye, fileMaxFiles: U, fileMaxFilesSize: be, fileInvalidTypeError: xe, fileCountExceededError: Se, fileSizeExceededError: Ce, attachmentsUploadError: we, attachments: Te, onAttachmentsChange: Ee, onAttachmentsMessage: De, attachmentsLabels: Oe, attachmentsDataTestId: ke, fileItemDataTestId: Ae, userAttachedFilesDataTestId: je, userFileItemDataTestId: Me, dataTestIds: W, downloadFile: Ne, messageActionsConfig: G, messageTimeGroupLabels: K, locale: q, feedbackTarget: Pe, onFeedbackChange: Fe, onFeedbackSubmit: qe, onFeedbackRemove: Je, onFeedbackCancel: Ze }) => {
	let Y = e(), Qe = (e, t) => {
		if (!G || e.isWelcome) return;
		let n = !!e.audioUrl || !!e.voiceMessageStatus, r = G.showCopyAction && !n && !!e.content && !e.hasError, i = G.showTimestamp && !!K && !!e.timestamp, a = G.showResponseFeedback && e.sender === "receiver" && !!e.messageId && !n && !!e.content && !e.hasError;
		if (!r && !i && !a) return;
		let o = e.timestamp instanceof Date ? e.timestamp.toISOString() : e.timestamp;
		return /* @__PURE__ */ J(He, {
			className: H(I.messageActions, I.messageActionsConfig),
			showTimestamp: i,
			showCopyAction: r,
			timestampLabel: i && K && e.timestamp ? C(e.timestamp, K, q) : void 0,
			timestampTooltip: i && o ? S(o, q) : void 0,
			copyText: e.content,
			copyIconPath: s.messageActionsIcons?.copyIcon,
			copySuccessIconPath: s.messageActionsIcons?.copySuccessIcon,
			copyAriaLabel: G.copyAriaLabel,
			copiedAriaLabel: G.copiedAriaLabel,
			onCopied: f,
			tooltipClassName: I.helperTooltip || void 0,
			tooltipContainer: Y,
			alwaysVisible: t,
			dataTestId: G.dataTestId,
			showResponseFeedback: a,
			feedback: e.feedback?.value ?? null,
			thumbUpIconPath: s.messageActionsIcons?.thumbUpIcon,
			thumbUpSelectedIconPath: s.messageActionsIcons?.thumbUpSelectedIcon,
			thumbDownIconPath: s.messageActionsIcons?.thumbDownIcon,
			thumbDownSelectedIconPath: s.messageActionsIcons?.thumbDownSelectedIcon,
			thumbsUpAriaLabel: G.thumbsUpAriaLabel,
			thumbsDownAriaLabel: G.thumbsDownAriaLabel,
			onFeedbackChange: (t) => Fe?.(e.messageId, t),
			readOnly: V
		});
	}, $e = (e) => e.hasError ? W?.errorMessage : e.sender === "receiver" ? W?.agentMessage : e.audioUrl || e.voiceMessageStatus ? W?.userVoiceMessage : W?.userMessage, et = {
		displayMode: D,
		buttonClassName: H(I.headerButton),
		newChatLabel: a.newChatLabel,
		onNewChat: V ? void 0 : p,
		onToggleFullscreen: x,
		isFullscreen: w,
		showFullscreenToggle: T,
		onClose: E,
		newChatIcon: O?.newChatIcon ?? void 0,
		expandIcon: O?.expandIcon ?? void 0,
		collapseIcon: O?.collapseIcon ?? void 0,
		dockIcon: O?.dockIcon ?? void 0,
		backIcon: O?.backIcon ?? void 0,
		newChatTooltip: P?.newChat,
		historyTooltip: P?.history,
		expandTooltip: P?.expand,
		collapseTooltip: P?.minimize,
		dockTooltip: P?.dock,
		backTooltip: P?.back,
		tooltipClassName: I.historyItemTooltip,
		tooltipContainer: Y
	}, tt = R(() => !j?.length || !pe ? [] : te(j, pe), [j, pe]), X = t.filter((e) => e.type !== l.AI_TRIGGER || e.sender !== "sender"), nt = X[X.length - 1]?.sender !== "receiver" || V ? void 0 : i?.length && !n ? /* @__PURE__ */ J(Ke, {
		prompts: i,
		onPromptSelected: u,
		className: H(I.suggestedPrompts, ...I.suggestedPromptsCustom) || void 0,
		tooltipClassName: I.helperTooltip || void 0,
		tooltipContainer: Y,
		dataTestId: W?.suggestedPrompts
	}) : r && a?.suggestedPrompts?.length ? /* @__PURE__ */ J(Ke, {
		prompts: a.suggestedPrompts,
		title: a.suggestedPromptsTitle,
		onPromptSelected: (e) => d ? d(e) : c(e.label),
		className: H(I.suggestedPrompts, ...I.suggestedPromptsCustom) || void 0,
		tooltipClassName: I.helperTooltip || void 0,
		tooltipContainer: Y,
		dataTestId: W?.suggestedPrompts
	}) : void 0;
	if (k === "history") return /* @__PURE__ */ J(Le, {
		"data-testid": W?.history,
		className: H(I.history, ...I.historyCustom),
		headerClassName: H(I.header, ...I.headerCustom, I.headerConfig),
		onBack: A,
		emptyStateText: N,
		title: a.historyTitle,
		onLoadMore: ie,
		hasMore: ae,
		loadingMore: oe,
		searchValue: se,
		onSearchChange: ce,
		onSearchClear: le,
		searchPlaceholder: ue,
		searchClearAriaLabel: de,
		searchIconPath: O?.searchIcon,
		searchClearIconPath: O?.searchClearIcon,
		searchClassName: I.historySearch || void 0,
		...et,
		children: tt.map((e) => /* @__PURE__ */ J(ze, {
			title: e.title,
			className: H(I.historySection),
			children: e.sessions.map((e) => /* @__PURE__ */ J(Re, {
				sessionId: e.sessionId,
				summary: e.summary,
				active: e.active,
				createdAt: e.createdAt,
				snippet: e.snippet,
				highlightText: fe,
				onSelectSession: M,
				className: H(I.historyItem),
				tooltipClassName: I.historyItemTooltip,
				tooltipContainer: Y,
				locale: _()?.locale
			}, e.sessionId))
		}, e.code))
	});
	let rt = {
		"data-testid": W?.header,
		className: H(I.header, ...I.headerCustom, I.headerConfig),
		chatAvatar: o.header,
		showAvatar: ee,
		title: a.title,
		subtitle: a.subtitle,
		showSeparator: a.showSeparator,
		onHistory: re,
		historyIcon: O?.historyIcon ?? void 0,
		...et
	};
	return /* @__PURE__ */ Xe(Ye, { children: [
		!ne && (m ? /* @__PURE__ */ Xe("div", {
			className: "flx-chat-header-wrapper",
			children: [/* @__PURE__ */ J(Ie, { ...rt }), /* @__PURE__ */ J("div", {
				className: "flx-chat-header-controls-slot",
				children: m
			})]
		}) : /* @__PURE__ */ J(Ie, { ...rt })),
		/* @__PURE__ */ Xe(We, {
			"data-testid": W?.messages,
			hasMoreMessages: me,
			loadingMore: he,
			onLoadMore: F,
			className: H(I.messages, I.userVoiceMessage, ...I.userVoiceMessageCustom, ...I.messagesCustom, I.messagesConfig),
			children: [X.map(({ id: e, messageId: t, feedback: n, sender: r, content: i, hasError: c, audioUrl: l, voiceMessageStatus: u, audioDuration: d, onRetryVoice: f, files: p, timestamp: m }, h) => /* @__PURE__ */ J(Ve, {
				message: {
					id: e,
					messageId: t,
					feedback: n,
					sender: r,
					content: i,
					hasError: c,
					audioUrl: l,
					voiceMessageStatus: u,
					audioDuration: d,
					onRetryVoice: f,
					files: p,
					timestamp: m
				},
				messageActions: Qe(X[h], h === X.length - 1),
				suggestedPrompts: h === X.length - 1 ? nt : void 0,
				chatAvatar: r === "receiver" ? o.agent : void 0,
				errorIcon: s.errorIcon || void 0,
				errorMessage: a.errorMessage,
				fetchAudio: ut,
				voicePlayIconPath: s.voiceMessageIcons?.playIcon,
				voicePauseIconPath: s.voiceMessageIcons?.pauseIcon,
				voiceRetryIconPath: s.voiceMessageIcons?.retryIcon,
				voiceSendingLabel: B?.sendingLabel,
				voiceErrorLabel: B?.errorLabel,
				voiceRetryAriaLabel: B?.retryAriaLabel,
				voiceMessageLabel: B?.messageLabel,
				voicePlayAriaLabel: B?.messagePlayAriaLabel,
				voicePauseAriaLabel: B?.messagePauseAriaLabel,
				voiceProgressAriaLabel: B?.progressAriaLabel,
				downloadIconPath: s.fileDownloadIcon || void 0,
				downloadFile: Ne,
				attachmentsLabels: Oe,
				userAttachedFilesDataTestId: je,
				userFileItemDataTestId: Me,
				dataTestId: $e(X[h]),
				className: H(r === "receiver" ? I.agentMessage : I.userMessage, ...r === "receiver" ? I.agentMessageCustom : I.userMessageCustom, r === "receiver" ? I.agentConfig : I.userConfig, r !== "receiver" && I.userFileAttachments, r !== "receiver" && I.userFileAttachmentsCustom && [...I.userFileAttachmentsCustom], c && I.errorMessage, c && I.errorMessageCustom && [...I.errorMessageCustom])
			}, `${e}-${r}`)), n ? /* @__PURE__ */ J(Ge, {
				dataTestId: W?.reasoning,
				className: H(I.reasoning),
				message: a.thinkingMessage,
				avatar: o.agent
			}) : null]
		}),
		G ? /* @__PURE__ */ J(Ue, {
			open: !!Pe,
			title: G.feedbackTitle,
			reasons: G.feedbackReasons,
			reason: Pe?.feedback?.reason ?? null,
			comment: Pe?.feedback?.comment ?? null,
			isEdit: !!Pe?.feedback,
			placeholder: G.feedbackPlaceholder,
			commentError: G.feedbackCommentError,
			cancelLabel: G.feedbackCancelLabel,
			submitLabel: G.feedbackSubmitLabel,
			removeLabel: G.feedbackRemoveLabel,
			onSubmit: (e) => qe?.(e),
			onCancel: () => Ze?.(),
			onRemove: () => Je?.(),
			className: I.feedbackModal,
			headerClassName: I.feedbackModalHeader,
			bodyClassName: I.messageFeedback,
			textAreaClassName: I.feedbackTextArea,
			errorClassName: I.feedbackError,
			buttonClassName: I.button,
			container: Y
		}) : null,
		/* @__PURE__ */ J(Be, {
			"data-testid": W?.input,
			textAreaDataTestId: W?.textInput,
			voiceInputDataTestId: W?.voiceInput,
			className: H(I.input, I.voiceInput, I.inputFileAttachments, ...I.inputCustom, ...I.voiceInputCustom, ...I.inputFileAttachmentsCustom, I.inputConfig),
			textAreaClassName: H(I.textArea),
			buttonClassName: H(I.button),
			inputPlaceholder: a.inputPlaceholder,
			sendAriaLabel: h,
			sendTooltip: g,
			stopAriaLabel: v,
			stopTooltip: y,
			tooltipClassName: I.helperTooltip || void 0,
			tooltipContainer: Y,
			voiceMicAriaLabel: b,
			sendIconPath: s.sendIcon || void 0,
			voiceMicIconPath: s.voiceMicIcon || void 0,
			maxInputRows: typeof a.maxInputRows == "number" ? a.maxInputRows : void 0,
			sendMessage: c,
			messageInput: "",
			sendDisabled: n,
			inputDisabled: V,
			inputDisabledTooltip: _e,
			onStopResponse: ge,
			stopIconPath: s.stopIcon || void 0,
			onVoiceMessage: L,
			showVoiceInput: z && !V,
			voiceCancelIconPath: s.voiceInputIcons?.cancelIcon,
			voiceConfirmIconPath: s.voiceInputIcons?.confirmIcon,
			voiceDeleteIconPath: s.voiceInputIcons?.deleteIcon,
			voicePlayIconPath: s.voiceInputIcons?.playIcon,
			voicePauseIconPath: s.voiceInputIcons?.pauseIcon,
			voiceListeningLabel: B?.listeningLabel,
			voiceMessageLabel: B?.voiceMessageLabel,
			voiceCancelAriaLabel: B?.cancelAriaLabel,
			voiceConfirmAriaLabel: B?.confirmAriaLabel,
			voiceDeleteAriaLabel: B?.deleteAriaLabel,
			voicePlayAriaLabel: B?.inputPlayAriaLabel,
			voicePauseAriaLabel: B?.inputPauseAriaLabel,
			voiceProgressAriaLabel: B?.progressAriaLabel,
			showFileUpload: ve && !V,
			accept: ye,
			maxFiles: U,
			maxFilesSize: be,
			invalidFileTypeError: xe,
			filesExceededError: Se,
			filesSizeExceededError: Ce,
			uploadError: we,
			attachIconPath: s.attachFileIcon || void 0,
			deleteIconPath: s.fileDeleteIcon || void 0,
			attachmentsLabels: Oe,
			attachmentsDataTestId: ke,
			fileItemDataTestId: Ae,
			attachments: Te,
			onAttachmentsChange: Ee,
			onAttachmentsMessage: De
		})
	] });
}, ft = [], pt = ({ isOpen: e }) => {
	let [t, n] = B(0), r = ge(d.stream$, w()), i = ge(m.stream$, m.get()), a = r && i?.[r]?.chatHistory || ft;
	return L(() => {
		if (!r) {
			n(0);
			return;
		}
		if (e) {
			ae(r, a), n(0);
			return;
		}
		n(g(r, a));
	}, [
		e,
		a,
		r
	]), L(() => {
		if (!e) return;
		let t = setTimeout(() => n(0), s);
		return () => clearTimeout(t);
	}, [e]), t;
}, mt = (e) => R(() => {
	let t = (t) => e?.templateConfig?.find((e) => e?.componentIdentifier === t), n = (e, t) => e?.templateConfig?.find((e) => e?.componentIdentifier === t), r = t("CHAT_MESSAGES"), i = t("CHAT_HISTORY"), a = t("CHAT_INPUT"), o = n(r, "CHAT_USER_MESSAGE"), s = n(a, "CHAT_FILE_ATTACHMENTS"), c = n(r, "CHAT_USER_ATTACHED_FILES");
	return {
		header: t("CHAT_HEADER"),
		messages: r,
		input: a,
		agent: n(r, "CHAT_AGENT_MESSAGE"),
		user: o,
		reasoning: n(r, "CHAT_REASONING"),
		errorMessage: n(r, "CHAT_ERROR_MESSAGE"),
		history: i,
		historyItem: n(i, "CHAT_HISTORY_ITEM"),
		historySection: n(i, "CHAT_HISTORY_SECTION"),
		suggestedPrompts: n(r, "CHAT_SUGGESTED_PROMPTS"),
		userVoiceMessage: n(r, "CHAT_USER_VOICE_MESSAGE"),
		messageActions: n(r, "CHAT_MESSAGE_ACTIONS"),
		textInput: n(a, "CHAT_TEXT_INPUT"),
		voiceInput: n(a, "CHAT_VOICE_INPUT"),
		fileAttachments: s,
		fileItem: n(s, "CHAT_FILE_ITEM"),
		userAttachedFiles: c,
		userFileItem: n(c, "CHAT_USER_FILE_ITEM")
	};
}, [e?.templateConfig]), ht = {
	[c.FILL]: {
		chat: U.Chat,
		chatHeader: U.ChatHeader,
		chatMessages: U.ChatMessages,
		chatMessageActions: U.ChatMessageActions,
		chatMessageFeedback: U.ChatMessageFeedback,
		chatMessageFeedbackReason: U.ChatMessageFeedbackReason,
		chatInputArea: U.ChatInputArea,
		chatUserMessage: U.ChatUserMessage,
		chatUserVoiceMessage: U.ChatUserVoiceMessage,
		chatAgentMessage: U.ChatAgentMessage,
		chatErrorMessage: U.ChatErrorMessage,
		chatInput: U.ChatInput,
		chatVoiceInput: U.ChatVoiceInput,
		chatInputFileAttachments: U.ChatInputFileAttachments,
		chatInputFileItem: U.ChatInputFileItem,
		chatUserFileAttachments: U.ChatUserFileAttachments,
		chatUserFileItem: U.ChatUserFileItem,
		chatHeaderButton: U.ChatHeaderButton,
		chatHistory: U.ChatHistory,
		chatHistoryItem: U.ChatHistoryItem,
		chatHistorySection: U.ChatHistorySection,
		chatHistorySearch: U.ChatHistorySearch
	},
	[c.FLOATING]: {
		chat: U.ChatFloating,
		chatHeader: U.ChatHeaderFloating,
		chatMessages: U.ChatMessagesFloating,
		chatMessageActions: U.ChatMessageActionsFloating,
		chatMessageFeedback: U.ChatMessageFeedbackFloating,
		chatMessageFeedbackReason: U.ChatMessageFeedbackReasonFloating,
		chatInputArea: U.ChatInputAreaFloating,
		chatUserMessage: U.ChatUserMessageFloating,
		chatUserVoiceMessage: U.ChatUserVoiceMessageFloating,
		chatAgentMessage: U.ChatAgentMessageFloating,
		chatErrorMessage: U.ChatErrorMessageFloating,
		chatInput: U.ChatInputFloating,
		chatVoiceInput: U.ChatVoiceInputFloating,
		chatInputFileAttachments: U.ChatInputFileAttachmentsFloating,
		chatInputFileItem: U.ChatInputFileItemFloating,
		chatUserFileAttachments: U.ChatUserFileAttachmentsFloating,
		chatUserFileItem: U.ChatUserFileItemFloating,
		chatHeaderButton: U.ChatHeaderButtonFloating,
		chatHistory: U.ChatHistoryFloating,
		chatHistoryItem: U.ChatHistoryItemFloating,
		chatHistorySection: U.ChatHistorySectionFloating,
		chatHistorySearch: U.ChatHistorySearchFloating
	},
	[c.FULLSCREEN]: {
		chat: U.ChatFullScreen,
		chatHeader: U.ChatHeaderFullScreen,
		chatMessages: U.ChatMessagesFullScreen,
		chatMessageActions: U.ChatMessageActionsFullScreen,
		chatMessageFeedback: U.ChatMessageFeedbackFullScreen,
		chatMessageFeedbackReason: U.ChatMessageFeedbackReasonFullScreen,
		chatInputArea: U.ChatInputAreaFullScreen,
		chatUserMessage: U.ChatUserMessageFullScreen,
		chatUserVoiceMessage: U.ChatUserVoiceMessageFullScreen,
		chatAgentMessage: U.ChatAgentMessageFullScreen,
		chatErrorMessage: U.ChatErrorMessageFullScreen,
		chatInput: U.ChatInputFullScreen,
		chatVoiceInput: U.ChatVoiceInputFullScreen,
		chatInputFileAttachments: U.ChatInputFileAttachmentsFullScreen,
		chatInputFileItem: U.ChatInputFileItemFullScreen,
		chatUserFileAttachments: U.ChatUserFileAttachmentsFullScreen,
		chatUserFileItem: U.ChatUserFileItemFullScreen,
		chatHeaderButton: U.ChatHeaderButtonFullScreen,
		chatHistory: U.ChatHistoryFullScreen,
		chatHistoryItem: U.ChatHistoryItemFullScreen,
		chatHistorySection: U.ChatHistorySectionFullScreen,
		chatHistorySearch: U.ChatHistorySearchFullScreen
	}
}, gt = {
	showChatIcon: !0,
	showSeparator: !0,
	newChatLabel: "New chat",
	errorMessage: "Error message",
	canRegenerate: !0,
	regenerateLabel: "Regenerate",
	maxInputRows: 10,
	showAgentAvatar: !0
}, _t = (e) => {
	if (!e || typeof e != "object") return null;
	let t = e.value, n = e.appId, r = `${typeof n == "string" ? n : ""}${typeof t == "string" ? t : ""}`;
	return r ? E(r) ?? null : null;
}, Z = (e, t) => {
	let n = G(e, t);
	return n ? E(n) ?? null : null;
}, vt = (e) => {
	if (!e || typeof e != "object" || Array.isArray(e)) return;
	let t = e;
	if (typeof t.src == "string" && typeof t.alt == "string") return {
		src: t.src,
		alt: t.alt
	};
}, yt = (e, t) => {
	let n = mt(e), r = n.header?.displayOptions?.flowxProps, i = n.input?.displayOptions?.flowxProps, a = n.textInput?.displayOptions?.flowxProps, o = n.agent?.displayOptions?.flowxProps, s = n.errorMessage?.displayOptions?.flowxProps, l = n.suggestedPrompts?.displayOptions?.flowxProps, u = n.history?.displayOptions?.flowxProps, d = n.fileAttachments?.displayOptions?.flowxProps, f = n.fileItem?.displayOptions?.flowxProps, p = R(() => {
		let e = t?.displayTypes, n = !e?.length || e.length === 1 && e[0] === c.FILL, i = {
			...gt,
			thinkingMessage: t?.thinkingMessage,
			welcomeMessage: t?.welcomeMessage,
			title: r?.title,
			subtitle: r?.subtitle,
			showSeparator: r?.showSeparator,
			hideNewConversation: r?.hideNewConversation,
			hideHistory: r?.hideHistory,
			showChatIcon: r?.showIcon,
			newChatLabel: r?.newChatLabel,
			showAgentAvatar: o?.showIcon,
			maxInputRows: a?.maxInputRows,
			inputPlaceholder: a?.placeholder,
			errorMessage: s?.genericError,
			regenerateLabel: s?.regenerateLabel,
			historyTitle: u?.title,
			hideHeader: n ? t?.hideHeader : void 0
		}, d = oe(l?.prompts), f = l?.title;
		return {
			...i,
			title: i.title ? M(i.title) : i.title,
			subtitle: i.subtitle ? M(i.subtitle) : i.subtitle,
			welcomeMessage: i.welcomeMessage ? M(i.welcomeMessage) : i.welcomeMessage,
			thinkingMessage: i.thinkingMessage ? M(i.thinkingMessage) : i.thinkingMessage,
			inputPlaceholder: i.inputPlaceholder ? M(i.inputPlaceholder) : i.inputPlaceholder,
			errorMessage: i.errorMessage ? M(i.errorMessage) : i.errorMessage,
			regenerateLabel: i.regenerateLabel ? M(i.regenerateLabel) : i.regenerateLabel,
			newChatLabel: i.newChatLabel ? M(i.newChatLabel) : i.newChatLabel,
			historyTitle: i.historyTitle ? M(i.historyTitle) : i.historyTitle,
			suggestedPrompts: d.map((e) => ({
				label: M(e.label),
				prompt: e.prompt
			})),
			suggestedPromptsTitle: f && M(f)
		};
	}, [
		r,
		i,
		a,
		o,
		s,
		l,
		u,
		t
	]), m = R(() => {
		let e = {};
		for (let t of [
			c.FILL,
			c.FLOATING,
			c.FULLSCREEN
		]) {
			let n = ht[t];
			e[t] = {
				headerIcon: _t(r?.headerIcon) ?? Z(n.chatHeader, "headerIcon"),
				agentIcon: _t(o?.agentIcon) ?? Z(n.chatAgentMessage, "agentIcon"),
				sendIcon: _t(i?.sendIcon) ?? Z(n.chatInputArea, "sendMessageIcon"),
				stopIcon: Z(n.chatInputArea, "stopResponseIcon"),
				voiceMicIcon: Z(n.chatInputArea, "voiceInputIcon"),
				errorIcon: _t(s?.errorIcon) ?? Z(n.chatErrorMessage, "errorIcon"),
				voiceInputIcons: {
					cancelIcon: Z(n.chatVoiceInput, "cancelIcon"),
					confirmIcon: Z(n.chatVoiceInput, "confirmIcon"),
					deleteIcon: Z(n.chatVoiceInput, "deleteIcon"),
					playIcon: Z(n.chatVoiceInput, "playIcon"),
					pauseIcon: Z(n.chatVoiceInput, "pauseIcon")
				},
				voiceMessageIcons: {
					playIcon: Z(n.chatUserVoiceMessage, "playIcon"),
					pauseIcon: Z(n.chatUserVoiceMessage, "pauseIcon"),
					retryIcon: Z(n.chatUserVoiceMessage, "retryIcon")
				},
				attachFileIcon: Z(n.chatInputArea, "attachFileIcon"),
				fileDeleteIcon: Z(n.chatInputFileItem, "deleteIcon"),
				fileDownloadIcon: Z(n.chatUserFileItem, "downloadIcon"),
				messageActionsIcons: {
					copyIcon: Z(n.chatMessageActions, "copyIcon"),
					copySuccessIcon: Z(n.chatMessageActions, "copySuccessIcon"),
					thumbUpIcon: Z(n.chatMessageActions, "thumbUpIcon"),
					thumbUpSelectedIcon: Z(n.chatMessageActions, "thumbUpSelectedIcon"),
					thumbDownIcon: Z(n.chatMessageActions, "thumbDownIcon"),
					thumbDownSelectedIcon: Z(n.chatMessageActions, "thumbDownSelectedIcon")
				}
			};
		}
		return e;
	}, [
		o?.agentIcon,
		r?.headerIcon,
		i?.sendIcon,
		s?.errorIcon
	]), h = R(() => ({
		showFileUpload: i?.fileAttachmentsEnabled ?? !1,
		accept: d?.accept ?? "*/*",
		maxFiles: d?.maxFiles ?? 10,
		maxFilesSize: d?.maxFilesSize ?? 5e6,
		invalidTypeError: j(d?.invalidFileType ?? ""),
		countExceededError: j(d?.filesExceeded ?? ""),
		sizeExceededError: j(d?.filesSizeExceeded ?? ""),
		dataTestId: d?.dataTestId,
		fileItemDataTestId: f?.dataTestId
	}), [
		i?.fileAttachmentsEnabled,
		d,
		f
	]), g = R(() => {
		let e = (e) => e?.displayOptions?.flowxProps?.dataTestId;
		return {
			header: e(n.header),
			messages: e(n.messages),
			input: e(n.input),
			textInput: e(n.textInput),
			voiceInput: e(n.voiceInput),
			agentMessage: e(n.agent),
			userMessage: e(n.user),
			errorMessage: e(n.errorMessage),
			userVoiceMessage: e(n.userVoiceMessage),
			reasoning: e(n.reasoning),
			suggestedPrompts: e(n.suggestedPrompts),
			history: e(n.history)
		};
	}, [n]), _ = R(() => {
		let e = {};
		for (let t of [
			c.FILL,
			c.FLOATING,
			c.FULLSCREEN
		]) {
			let n = ht[t].chatHeader, i = ht[t].chatHistorySearch;
			e[t] = {
				newChatIcon: _t(r?.newChatIcon) ?? Z(n, "newChatIcon"),
				expandIcon: Z(n, "expandIcon"),
				collapseIcon: Z(n, "collapseIcon"),
				dockIcon: Z(n, "dockIcon") ?? Z(n, "closeIcon"),
				historyIcon: _t(r?.historyIcon) ?? Z(n, "historyIcon"),
				backIcon: _t(r?.backIcon) ?? Z(n, "backIcon"),
				searchIcon: Z(i, "searchIcon"),
				searchClearIcon: Z(i, "clearIcon")
			};
		}
		return e;
	}, [
		r?.newChatIcon,
		r?.historyIcon,
		r?.backIcon
	]);
	return {
		chatConfig: p,
		chatIconsByMode: m,
		chatHeaderAvatar: R(() => {
			if (p.showChatIcon === !1) return;
			let e = m[c.FILL].headerIcon;
			return e ? {
				src: e,
				alt: "Chat header icon"
			} : vt(t?.chatAvatar);
		}, [
			p.showChatIcon,
			m,
			t?.chatAvatar
		]),
		headerActionIconsByMode: _,
		fileUploadConfig: h,
		dataTestIds: g,
		templateConfigs: n,
		chatHeaderFlowxProps: r,
		chatInputFlowxProps: i,
		chatTextInputFlowxProps: a,
		chatAgentFlowxProps: o,
		chatErrorFlowxProps: s
	};
}, bt = () => {
	let [e, t] = B([]), [n, r] = B(null), [i, a] = B(!0), [o, s] = B(!1), c = R(() => ve([m.stream$, d.stream$]).pipe(ye(([e, t]) => ({
		store: e,
		currentId: t
	}))), []);
	return V(c, ({ store: e, currentId: n }) => {
		r(n);
		let i = Object.entries(e).filter(([, e]) => !e.isLocalOnly && e.isSessionUpdated).map(([e, t]) => ({
			sessionId: e,
			summary: t.summary,
			messageCount: t.messageCount,
			active: e === n,
			createdAt: t.createdAt
		}));
		t(i);
	}), V(v.stream$, (e) => {
		a(e.hasMore), s(e.loading);
	}), {
		sessions: e,
		activeSessionId: n,
		selectSession: F((e) => {
			de(e), P("chatSessionId", e), k(e);
		}, []),
		hasMoreSessions: i,
		loadingMoreSessions: o
	};
};
//#endregion
//#region libs/sdk/react/src/lib/hooks/useAttachmentsUpload.ts
function xt(e, t) {
	let [n, r] = B([]), [i, a] = B(null);
	return {
		attachments: n,
		setAttachments: r,
		uploadError: i,
		handleAttachmentsMessage: F(async ({ message: n, files: i }) => {
			a(null);
			try {
				let a = ce(), o = await me(a, i), s = f(n, o);
				e.current?.(n, s), t?.(), r([]);
			} catch (e) {
				console.error("[AttachmentsUpload] Upload failed:", e);
				let t = j("@@sys_chat_attachments_upload_error");
				a(t), fe({
					messageType: "error",
					message: t,
					hideCloseButton: !0,
					closeInterval: 3e3,
					withTheme: !0
				});
			}
		}, [e, t]),
		clearAttachments: F(() => {
			r([]), a(null);
		}, [])
	};
}
//#endregion
//#region libs/sdk/react/src/lib/hooks/useResolveAudioUrls.ts
function St(e, t) {
	let n = z(/* @__PURE__ */ new Map()), r = (e) => e.map((e) => {
		if (!e.audioUrl) return e;
		let t = n.current.get(e.audioUrl);
		return t ? {
			...e,
			audioUrl: t
		} : e;
	}), i = F((e, t) => {
		t instanceof Blob && n.current.set(e, URL.createObjectURL(t));
	}, []);
	return L(() => {
		let e = n;
		return () => {
			e.current.forEach((e) => {
				e.startsWith("blob:") && URL.revokeObjectURL(e);
			}), e.current.clear();
		};
	}, []), {
		applyCachedAudioUrls: r,
		seedCache: i
	};
}
//#endregion
//#region libs/sdk/react/src/components/ui-wrapper/chat/utils/messageUtils.ts
var Ct = () => typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`, wt = (e, t = "receiver") => e.map((e) => ({
	...e,
	id: e.id ?? Ct(),
	sender: e.sender ?? t,
	timestamp: e.timestamp ?? /* @__PURE__ */ new Date(),
	type: e.type
})), Tt = (e) => ({
	id: Ct(),
	content: e,
	sender: "receiver",
	timestamp: /* @__PURE__ */ new Date(),
	isWelcome: !0
}), Et = (e) => {
	let t = ht[e], n = [
		"chat",
		"chatHeader",
		"chatMessages",
		"chatMessageActions",
		"chatMessageFeedback",
		"chatMessageFeedbackReason",
		"chatInputArea",
		"chatUserMessage",
		"chatUserVoiceMessage",
		"chatAgentMessage",
		"chatErrorMessage",
		"chatInput",
		"chatVoiceInput",
		"chatInputFileAttachments",
		"chatInputFileItem",
		"chatUserFileAttachments",
		"chatUserFileItem",
		"chatHeaderButton",
		"chatHistory",
		"chatHistoryItem",
		"chatHistorySection",
		"chatHistorySearch"
	], r = {};
	for (let e of n) r[e] = K(t[e]);
	return r;
}, Dt = () => ({
	[c.FILL]: Et(c.FILL),
	[c.FLOATING]: Et(c.FLOATING),
	[c.FULLSCREEN]: Et(c.FULLSCREEN)
}), Ot = (e, r = !1, a = {}) => {
	let [o, s] = B([]), c = z(!1), [u, d] = B(!1), [f, p] = B(!1), [m, h] = B([]), [g, v] = B(!1), [y, x] = B(!1), [S, C] = B(null), w = z(null), E = z(null), D = z(null), te = ge(pe, null), k = R(() => te?.chatWorkflow?.resDefId, [te]), re = z(/* @__PURE__ */ new Map()), A = t(a), { applyCachedAudioUrls: j, seedCache: M } = St(o, s), { pendingVoice: ie, handleVoiceMessage: ae, handleRetryVoice: oe, clearPendingVoice: N, checkAndClearPendingVoice: se } = n(M, w, d, a.voiceInput), { attachments: ce, setAttachments: le, uploadError: de, handleAttachmentsMessage: fe, clearAttachments: me } = xt(w, A.textMessageSent);
	return L(() => {
		r && (me(), N());
	}, [
		r,
		me,
		N
	]), L(() => {
		let t = !0;
		if (!k) {
			s(wt([Tt(e.welcomeMessage || "Welcome to the chat!")]));
			return;
		}
		return d(!1), C(null), N(), ee("chatSessionId") || (p(!0), s(wt([Tt(e.welcomeMessage || "Welcome to the chat!")]))), ne({
			cache: !1,
			source: {
				type: "WORKFLOW",
				id: k
			}
		}).then(({ sendMessage: e, chat$: n, loadMoreMessages: r, stopResponse: i }) => {
			t && (w.current = e, E.current = r, D.current = i, C(n));
		}).catch((n) => {
			console.error("Error initializing chat:", n), t && s(wt([Tt(e.welcomeMessage || "Welcome to the chat!")]));
		}), () => {
			t = !1, b();
		};
	}, [
		e.welcomeMessage,
		k,
		N
	]), V(S ?? _e, ({ chatHistory: t, loading: n, isLocalOnly: r, hasMoreMessages: i, loadingMore: a }) => {
		if (d(n), v(i ?? !1), x(a ?? !1), p(r), r) h([]), s([Tt(e.welcomeMessage || "Welcome to the chat!")]);
		else {
			h(T(t ?? []));
			let e = t?.filter((e) => e.message || e.type === l.AUDIO || e.type === l.ATTACHMENTS).map((e) => {
				let t = e._id ?? Ct(), n = e.type === l.AUDIO, r;
				if (n && e.audioFile?.downloadPath) {
					let { apiUrl: t } = _();
					r = `${t}/document/${e.audioFile.downloadPath}`;
				}
				let i = e.type === l.ATTACHMENTS, a;
				if (i && e.files?.length) {
					let { apiUrl: t } = _();
					a = e.files.map((e) => {
						let n = e.originalFileName || e.downloadPath.split("/").pop() || e.downloadPath;
						return {
							name: n,
							extension: Je(n),
							mimeType: e.mimeType ?? "",
							downloadUrl: `${t}/document/${e.downloadPath}`
						};
					});
				}
				return {
					id: t,
					messageId: e.messageId,
					feedback: e.feedback ?? null,
					content: n ? "" : e.message || "",
					sender: e.actor === "human" ? "sender" : "receiver",
					timestamp: ue(t, e.timestamp, re.current),
					hasError: e.hasError,
					...r ? { audioUrl: r } : {},
					...n && e.audioFile?.duration ? { audioDuration: e.audioFile.duration } : {},
					...a ? { files: a } : {},
					type: e.type
				};
			}) ?? [];
			se(e), s(j(e));
		}
	}), {
		messages: R(() => i(o, ie, (e, t) => ({
			id: e.id,
			content: "",
			sender: "sender",
			timestamp: /* @__PURE__ */ new Date(),
			voiceMessageStatus: e.status,
			audioDuration: e.duration,
			onRetryVoice: t,
			...e.downloadUrl ? { audioUrl: e.downloadUrl } : {}
		}), oe), [
			o,
			ie,
			oe
		]),
		reasoning: u,
		showSuggestedPrompts: f,
		agentSuggestions: m,
		handleSendMessage: F((e) => {
			c.current = !0, w.current && (w.current(e), A.textMessageSent());
		}, [A]),
		handleResendMessage: F((e) => {
			c.current = !0, w.current?.(e);
		}, []),
		handleSendSuggestedPrompt: F((e) => {
			c.current = !0, w.current && (w.current(e.label, {
				type: l.SUGGESTED_PROMPT,
				label: e.label,
				prompt: e.prompt || ""
			}), A.agentPromptSelected());
		}, [A]),
		handleSendConfiguredPrompt: F((e) => {
			c.current = !0, w.current && (w.current(e.label), A.configuredPromptSelected(e.label));
		}, [A]),
		handleNewChat: F(() => {
			O(), P("chatSessionId", null), c.current = !1, re.current.clear(), s([Tt(e.welcomeMessage || "Welcome to the chat!")]), d(!1), p(!0), h([]), N(), me();
		}, [
			e.welcomeMessage,
			N,
			me
		]),
		hasMoreMessages: g,
		loadingMore: y,
		handleLoadMore: F(() => {
			g && !y && E.current?.();
		}, [g, y]),
		handleVoiceMessage: ae,
		handleStopResponse: F(() => {
			D.current?.();
		}, []),
		attachments: ce,
		onAttachmentsChange: le,
		attachmentsUploadError: de,
		handleAttachmentsMessage: fe
	};
}, kt = {
	fill: [],
	floating: [],
	fullscreen: []
}, At = [
	"fill",
	"floating",
	"fullscreen"
];
function jt(e) {
	switch (e) {
		case U.ChatHeader: return (e) => we(e);
		case U.ChatMessages: return (e) => De(e);
		case U.ChatAgentMessage: return (e) => be(e);
		case U.ChatUserMessage: return (e) => je(e);
		case U.ChatUserVoiceMessage: return (e) => Me(e);
		case U.ChatUserFileAttachments: return (e) => ke(e);
		case U.ChatUserFileItem: return (e) => Ae(e);
		case U.ChatInput: return (e) => Ee(e);
		case U.ChatVoiceInput: return (e) => W(e);
		case U.ChatInputFileAttachments: return (e) => Se(e);
		case U.ChatInputFileItem: return (e) => Ce(e);
		case U.ChatErrorMessage: return (e) => xe(e);
		case U.ChatSuggestedPrompts: return (e) => Oe(e);
		case U.ChatHistory: return (e) => Te(e);
		default: return null;
	}
}
var Q = (e, t) => {
	let [n, r] = B(kt);
	return L(() => {
		let i = jt(t);
		if (!i || !e) {
			r((e) => Ze(e, kt) ? e : kt);
			return;
		}
		let a = {
			fill: [],
			floating: [],
			fullscreen: []
		};
		for (let t of At) {
			let n = e[t];
			a[t] = n ? [Ne(n), i(n)].filter(Boolean) : [];
		}
		Ze(a, n) || r(a);
	}, [
		e,
		n,
		t
	]), n;
}, Mt = (e, t) => {
	let n = R(() => Dt(), []), r = n[c.FILL].chat ?? null, i = n[c.FLOATING].chat ?? null, a = n[c.FULLSCREEN].chat ?? null, o = n[c.FILL].chatVoiceInput ?? null, s = n[c.FLOATING].chatVoiceInput ?? null, l = n[c.FULLSCREEN].chatVoiceInput ?? null, u = n[c.FILL].chatUserVoiceMessage ?? null, d = n[c.FLOATING].chatUserVoiceMessage ?? null, f = n[c.FULLSCREEN].chatUserVoiceMessage ?? null, p = n[c.FILL].chatHeader ?? null, m = n[c.FLOATING].chatHeader ?? null, h = n[c.FULLSCREEN].chatHeader ?? null, g = n[c.FILL].chatMessages ?? null, _ = n[c.FLOATING].chatMessages ?? null, v = n[c.FULLSCREEN].chatMessages ?? null, y = n[c.FILL].chatInputArea ?? null, b = n[c.FLOATING].chatInputArea ?? null, x = n[c.FULLSCREEN].chatInputArea ?? null, S = n[c.FILL].chatUserMessage ?? null, C = n[c.FLOATING].chatUserMessage ?? null, w = n[c.FULLSCREEN].chatUserMessage ?? null, T = n[c.FILL].chatAgentMessage ?? null, E = n[c.FLOATING].chatAgentMessage ?? null, D = n[c.FULLSCREEN].chatAgentMessage ?? null, ee = n[c.FILL].chatErrorMessage ?? null, te = n[c.FLOATING].chatErrorMessage ?? null, ne = n[c.FULLSCREEN].chatErrorMessage ?? null, O = n[c.FILL].chatInput ?? null, k = n[c.FLOATING].chatInput ?? null, re = n[c.FULLSCREEN].chatInput ?? null, A = n[c.FILL].chatHeaderButton ?? null, j = n[c.FLOATING].chatHeaderButton ?? null, M = n[c.FULLSCREEN].chatHeaderButton ?? null, ie = n[c.FILL].chatHistory ?? null, ae = n[c.FLOATING].chatHistory ?? null, oe = n[c.FULLSCREEN].chatHistory ?? null, N = n[c.FILL].chatHistoryItem ?? null, se = n[c.FLOATING].chatHistoryItem ?? null, ce = n[c.FULLSCREEN].chatHistoryItem ?? null, le = n[c.FILL].chatHistorySection ?? null, ue = n[c.FLOATING].chatHistorySection ?? null, de = n[c.FULLSCREEN].chatHistorySection ?? null, fe = K(U.HelperTooltip), pe = K(U.Button), P = K(U.Textarea), me = K(U.Error), he = K(U.Modal), F = K(U.ModalHeader), I = e?.fill ?? {}, L = e?.floating ?? {}, z = e?.fullscreen ?? {}, B = e?.floating?.fab ?? {}, ge = e?.fullscreen?.fab ?? {}, V = B.notification ?? {}, H = ge.notification ?? {}, _e = e?.floating?.position ?? null, ve = e?.fullscreen?.position ?? null, ye = Pe({
		styles: _e,
		isChat: !0
	}), be = Pe({
		styles: ve,
		isChat: !0
	}), xe = q({
		styles: I,
		component: U.Chat
	}), Se = q({
		styles: L,
		component: U.Chat
	}), Ce = q({
		styles: z,
		component: U.Chat
	}), we = Q(t.header?.displayOptions?.style, U.ChatHeader), Te = Q(t.messages?.displayOptions?.style, U.ChatMessages), Ee = Q(t.agent?.displayOptions?.style, U.ChatAgentMessage), De = Q(t.user?.displayOptions?.style, U.ChatUserMessage), Oe = Q(t.userVoiceMessage?.displayOptions?.style, U.ChatUserVoiceMessage), ke = Q(t.input?.displayOptions?.style, U.ChatInput), Ae = Q(t.voiceInput?.displayOptions?.style, U.ChatVoiceInput), je = Q(t.errorMessage?.displayOptions?.style, U.ChatErrorMessage), Me = Q(t.suggestedPrompts?.displayOptions?.style, U.ChatSuggestedPrompts), W = Q(t.history?.displayOptions?.style, U.ChatHistory), Ne = Q(t.fileAttachments?.displayOptions?.style, U.ChatInputFileAttachments), G = Q(t.fileItem?.displayOptions?.style, U.ChatInputFileItem), Fe = Q(t.userAttachedFiles?.displayOptions?.style, U.ChatUserFileAttachments), Ie = Q(t.userFileItem?.displayOptions?.style, U.ChatUserFileItem), Le = q({
		styles: B,
		component: U.ChatFabFloating
	}), Re = q({
		styles: ge,
		component: U.ChatFabFullScreen
	}), ze = q({
		styles: V,
		component: U.ChatFabNotificationFloating
	}), Be = q({
		styles: H,
		component: U.ChatFabNotificationFullScreen
	});
	return {
		classNamesByMode: n,
		chatClassName: r,
		chatClassNameFloating: i,
		chatClassNameFullScreen: a,
		chatVoiceInputClassName: o,
		chatVoiceInputClassNameFloating: s,
		chatVoiceInputClassNameFullScreen: l,
		chatUserVoiceMessageClassName: u,
		chatUserVoiceMessageClassNameFloating: d,
		chatUserVoiceMessageClassNameFullScreen: f,
		chatHeaderClassName: p,
		chatHeaderClassNameFloating: m,
		chatHeaderClassNameFullScreen: h,
		chatMessagesClassName: g,
		chatMessagesClassNameFloating: _,
		chatMessagesClassNameFullScreen: v,
		chatInputAreaClassName: y,
		chatInputAreaClassNameFloating: b,
		chatInputAreaClassNameFullScreen: x,
		chatUserMessageClassName: S,
		chatUserMessageClassNameFloating: C,
		chatUserMessageClassNameFullScreen: w,
		chatAgentMessageClassName: T,
		chatAgentMessageClassNameFloating: E,
		chatAgentMessageClassNameFullScreen: D,
		chatErrorMessageClassName: ee,
		chatErrorMessageClassNameFloating: te,
		chatErrorMessageClassNameFullScreen: ne,
		textAreaClassName: O,
		textAreaClassNameFloating: k,
		textAreaClassNameFullScreen: re,
		formTextAreaClassName: P,
		formErrorClassName: me,
		modalClassName: he,
		modalHeaderClassName: F,
		chatHeaderButtonClassName: A,
		chatHeaderButtonClassNameFloating: j,
		chatHeaderButtonClassNameFullScreen: M,
		chatHistoryClassName: ie,
		chatHistoryClassNameFloating: ae,
		chatHistoryClassNameFullScreen: oe,
		chatHistoryItemClassName: N,
		chatHistoryItemClassNameFloating: se,
		chatHistoryItemClassNameFullScreen: ce,
		chatHistorySectionClassName: le,
		chatHistorySectionClassNameFloating: ue,
		chatHistorySectionClassNameFullScreen: de,
		helperTooltipClassName: fe,
		buttonClassName: pe,
		chatCustomClassName: xe,
		chatFloatingCustomClassName: Se,
		chatFullscreenCustomClassName: Ce,
		chatHeaderCustomClassName: we.fill,
		chatHeaderCustomClassNameFloating: we.floating,
		chatHeaderCustomClassNameFullScreen: we.fullscreen,
		chatMessagesCustomClassName: Te.fill,
		chatMessagesCustomClassNameFloating: Te.floating,
		chatMessagesCustomClassNameFullScreen: Te.fullscreen,
		chatAgentMessageCustomClassName: Ee.fill,
		chatAgentMessageCustomClassNameFloating: Ee.floating,
		chatAgentMessageCustomClassNameFullScreen: Ee.fullscreen,
		chatUserMessageCustomClassName: De.fill,
		chatUserMessageCustomClassNameFloating: De.floating,
		chatUserMessageCustomClassNameFullScreen: De.fullscreen,
		chatInputCustomClassName: ke.fill,
		chatInputCustomClassNameFloating: ke.floating,
		chatInputCustomClassNameFullScreen: ke.fullscreen,
		chatErrorMessageCustomClassName: je.fill,
		chatErrorMessageCustomClassNameFloating: je.floating,
		chatErrorMessageCustomClassNameFullScreen: je.fullscreen,
		chatSuggestedPromptsCustomClassName: Me.fill,
		chatSuggestedPromptsCustomClassNameFloating: Me.floating,
		chatSuggestedPromptsCustomClassNameFullScreen: Me.fullscreen,
		chatHistoryCustomClassName: W.fill,
		chatHistoryCustomClassNameFloating: W.floating,
		chatHistoryCustomClassNameFullScreen: W.fullscreen,
		chatUserVoiceMessageCustomClassName: Oe.fill,
		chatUserVoiceMessageCustomClassNameFloating: Oe.floating,
		chatUserVoiceMessageCustomClassNameFullScreen: Oe.fullscreen,
		chatVoiceInputCustomClassName: Ae.fill,
		chatVoiceInputCustomClassNameFloating: Ae.floating,
		chatVoiceInputCustomClassNameFullScreen: Ae.fullscreen,
		fabCustomClassNameFloating: Le,
		fabCustomClassNameFullScreen: Re,
		fabNotificationCustomClassNameFloating: ze,
		fabNotificationCustomClassNameFullScreen: Be,
		chatInputFileAttachmentsCustomStyles: Ne,
		chatInputFileItemCustomStyles: G,
		chatUserFileAttachmentsCustomStyles: Fe,
		chatUserFileItemCustomStyles: Ie,
		popupPositionClassNameFloating: ye,
		popupPositionClassNameFullscreen: be,
		chatHeaderConfigClassName: t.header?.displayOptions?.className ?? void 0,
		chatMessagesConfigClassName: t.messages?.displayOptions?.className ?? void 0,
		chatInputConfigClassName: t.input?.displayOptions?.className ?? void 0,
		chatAgentConfigClassName: t.agent?.displayOptions?.className ?? void 0,
		chatUserConfigClassName: t.user?.displayOptions?.className ?? void 0,
		chatReasoningConfigClassName: t.reasoning?.displayOptions?.className ?? void 0,
		chatMessageActionsConfigClassName: t.messageActions?.displayOptions?.className ?? void 0
	};
};
//#endregion
//#region libs/sdk/react/src/components/ui-wrapper/chat/useFlxChatWrapperState.ts
function Nt(e) {
	let { displayOptions: { className: n, flowxProps: i } = {
		className: null,
		flowxProps: {}
	}, flowxUuid: o } = e ?? {
		displayOptions: {},
		flowxUuid: ""
	}, s = D()?.chatWorkflow?.resDefId, [c, l] = B("chat"), u = yt(e, i), d = u.chatInputFlowxProps?.disabled, f = a({
		config: u.templateConfigs.input,
		expression: d ?? "",
		logType: "disabled"
	}), { templateConfigs: m } = u, h = {
		chat: e,
		textInput: m.textInput,
		suggestedPrompts: m.suggestedPrompts,
		voiceInput: m.voiceInput,
		messageActions: m.messageActions
	}, g = t(h), _ = Ot(u.chatConfig, f, h), { messages: v, handleResendMessage: y } = _, b = F(() => {
		let e = [...v].reverse().find((e) => e.sender === "sender");
		e?.content && y(e.content);
	}, [v, y]), S = Mt(e?.displayOptions?.style, u.templateConfigs), C = bt(), w = st(s), T = r(h.messageActions), E = F(async () => {
		if (s) try {
			await re(s);
		} catch (e) {
			console.error("Failed to load conversations list", e);
		}
		l("history");
	}, [s]), ee = F(() => {
		w.clearSearch(), l("chat");
	}, [w.clearSearch]), te = F(async () => {
		s && await A(s);
	}, [s]), ne = F(() => {
		_.handleNewChat(), l("chat");
	}, [_.handleNewChat]), O = F((e) => {
		C.selectSession(e), w.clearSearch(), l("chat");
	}, [C.selectSession, w.clearSearch]), k = F(async (e) => {
		if (!e.downloadUrl) return;
		let t = await x(e.downloadUrl);
		if (!t) return;
		let n = URL.createObjectURL(t), r = document.createElement("a");
		r.href = n, r.download = e.name, r.click(), URL.revokeObjectURL(n);
	}, []), M = u.templateConfigs.messageActions?.displayOptions?.flowxProps, ie = u.templateConfigs.messageActions ? le(M, j) : void 0;
	return {
		flowxUuid: o,
		className: n,
		flowxProps: i,
		displayOptions: e?.displayOptions,
		chatConfig: u.chatConfig,
		chatInputFlowxProps: u.chatInputFlowxProps,
		inputDisabled: f,
		inputDisabledTooltip: j("@@sys_chat_disabled_input"),
		chatIconsByMode: u.chatIconsByMode,
		headerActionIconsByMode: u.headerActionIconsByMode,
		fileUploadConfig: u.fileUploadConfig,
		userAttachedFilesDataTestId: u.templateConfigs.userAttachedFiles?.displayOptions?.flowxProps?.dataTestId,
		userFileItemDataTestId: u.templateConfigs.userFileItem?.displayOptions?.flowxProps?.dataTestId,
		dataTestIds: u.dataTestIds,
		messageActionsConfig: ie,
		feedbackTarget: T.feedbackTarget,
		handleFeedbackChange: T.handleFeedbackChange,
		handleFeedbackSubmit: T.handleFeedbackSubmit,
		handleFeedbackRemove: T.handleFeedbackRemove,
		handleFeedbackCancel: T.handleFeedbackCancel,
		messageTimeGroupLabels: p(j),
		messages: _.messages,
		reasoning: _.reasoning,
		showSuggestedPrompts: _.showSuggestedPrompts,
		agentSuggestions: _.agentSuggestions,
		hasMoreMessages: _.hasMoreMessages,
		loadingMore: _.loadingMore,
		handleLoadMore: _.handleLoadMore,
		handleSendMessage: _.handleSendMessage,
		handleSendSuggestedPrompt: _.handleSendSuggestedPrompt,
		handleSendConfiguredPrompt: _.handleSendConfiguredPrompt,
		chatAnalytics: g,
		handleNewChat: ne,
		handleVoiceMessage: _.handleVoiceMessage,
		handleStopResponse: _.handleStopResponse,
		handleRegenerate: b,
		attachments: _.attachments,
		onAttachmentsChange: _.onAttachmentsChange,
		attachmentsUploadError: _.attachmentsUploadError,
		handleAttachmentsMessage: _.handleAttachmentsMessage,
		downloadAttachment: k,
		attachmentsLabels: {
			attachAriaLabel: j("@@sys_a11y_chat_attach_files"),
			removeAriaLabel: j("@@sys_a11y_chat_remove_file"),
			downloadAriaLabel: j("@@sys_a11y_chat_download_file")
		},
		activeView: c,
		handleOpenHistory: E,
		handleCloseHistory: ee,
		handleSelectSession: O,
		handleLoadMoreSessions: te,
		chatSessions: C.sessions,
		hasMoreSessions: C.hasMoreSessions,
		loadingMoreSessions: C.loadingMoreSessions,
		searchText: w.searchText,
		handleSearchChange: w.onSearchChange,
		handleSearchClear: w.clearSearch,
		isSearchActive: w.isSearchActive,
		searchSessions: w.searchSessions,
		searchLoading: w.searchLoading,
		searchHighlightText: w.appliedQuery,
		searchPlaceholder: j("@@sys_chat_conversations_search_placeholder"),
		searchClearAriaLabel: j("@@sys_a11y_conversations_search_clear"),
		conversationsNoResultsText: j("@@sys_chat_conversations_no_results"),
		headerTooltips: {
			newChat: j("@@sys_chat_tooltip_new_chat"),
			history: j("@@sys_chat_tooltip_chat_history"),
			expand: j("@@sys_chat_tooltip_expand"),
			minimize: j("@@sys_chat_tooltip_minimize"),
			dock: j("@@sys_chat_tooltip_dock"),
			back: j("@@sys_chat_tooltip_back")
		},
		conversationsEmptyStateText: j("@@sys_chat_conversations_empty_state"),
		sessionGroupLabels: {
			sys_chat_time_group_today: j("@@sys_chat_time_group_today"),
			sys_chat_time_group_yesterday: j("@@sys_chat_time_group_yesterday"),
			sys_chat_time_group_previous_7_days: j("@@sys_chat_time_group_previous_7_days"),
			sys_chat_time_group_previous_30_days: j("@@sys_chat_time_group_previous_30_days"),
			sys_chat_time_group_older: j("@@sys_chat_time_group_older")
		},
		voiceLabels: {
			listeningLabel: j("@@sys_chat_voice_input_recording"),
			voiceMessageLabel: j("@@sys_chat_voice_input_message"),
			cancelAriaLabel: j("@@sys_a11y_chat_voice_input_cancel"),
			confirmAriaLabel: j("@@sys_a11y_chat_voice_input_confirm"),
			deleteAriaLabel: j("@@sys_a11y_chat_voice_input_delete"),
			inputPlayAriaLabel: j("@@sys_a11y_chat_voice_input_play"),
			inputPauseAriaLabel: j("@@sys_a11y_chat_voice_input_pause"),
			sendingLabel: j("@@sys_chat_voice_message_sending"),
			messageLabel: j("@@sys_chat_voice_message"),
			errorLabel: j("@@sys_chat_voice_message_error"),
			messagePlayAriaLabel: j("@@sys_a11y_chat_voice_message_play"),
			messagePauseAriaLabel: j("@@sys_a11y_chat_voice_message_pause"),
			retryAriaLabel: j("@@sys_a11y_chat_voice_message_retry"),
			progressAriaLabel: j("@@sys_a11y_chat_voice_message_progress")
		},
		chatHeaderAvatar: u.chatHeaderAvatar,
		chatHeaderConfigClassName: S.chatHeaderConfigClassName,
		chatMessagesConfigClassName: S.chatMessagesConfigClassName,
		chatInputConfigClassName: S.chatInputConfigClassName,
		chatAgentConfigClassName: S.chatAgentConfigClassName,
		chatUserConfigClassName: S.chatUserConfigClassName,
		chatReasoningConfigClassName: S.chatReasoningConfigClassName,
		chatMessageActionsConfigClassName: S.chatMessageActionsConfigClassName,
		chatClassNamesByMode: S.classNamesByMode,
		chatInputFileAttachmentsCustomStyles: S.chatInputFileAttachmentsCustomStyles,
		chatInputFileItemCustomStyles: S.chatInputFileItemCustomStyles,
		chatUserFileAttachmentsCustomStyles: S.chatUserFileAttachmentsCustomStyles,
		chatUserFileItemCustomStyles: S.chatUserFileItemCustomStyles,
		chatClassName: S.chatClassName,
		chatClassNameFloating: S.chatClassNameFloating,
		chatClassNameFullScreen: S.chatClassNameFullScreen,
		chatVoiceInputClassName: S.chatVoiceInputClassName,
		chatVoiceInputClassNameFloating: S.chatVoiceInputClassNameFloating,
		chatVoiceInputClassNameFullScreen: S.chatVoiceInputClassNameFullScreen,
		chatUserVoiceMessageClassName: S.chatUserVoiceMessageClassName,
		chatUserVoiceMessageClassNameFloating: S.chatUserVoiceMessageClassNameFloating,
		chatUserVoiceMessageClassNameFullScreen: S.chatUserVoiceMessageClassNameFullScreen,
		chatHeaderClassName: S.chatHeaderClassName,
		chatHeaderClassNameFloating: S.chatHeaderClassNameFloating,
		chatHeaderClassNameFullScreen: S.chatHeaderClassNameFullScreen,
		chatMessagesClassName: S.chatMessagesClassName,
		chatMessagesClassNameFloating: S.chatMessagesClassNameFloating,
		chatMessagesClassNameFullScreen: S.chatMessagesClassNameFullScreen,
		chatInputAreaClassName: S.chatInputAreaClassName,
		chatInputAreaClassNameFloating: S.chatInputAreaClassNameFloating,
		chatInputAreaClassNameFullScreen: S.chatInputAreaClassNameFullScreen,
		chatUserMessageClassName: S.chatUserMessageClassName,
		chatUserMessageClassNameFloating: S.chatUserMessageClassNameFloating,
		chatUserMessageClassNameFullScreen: S.chatUserMessageClassNameFullScreen,
		chatAgentMessageClassName: S.chatAgentMessageClassName,
		chatAgentMessageClassNameFloating: S.chatAgentMessageClassNameFloating,
		chatAgentMessageClassNameFullScreen: S.chatAgentMessageClassNameFullScreen,
		chatErrorMessageClassName: S.chatErrorMessageClassName,
		chatErrorMessageClassNameFloating: S.chatErrorMessageClassNameFloating,
		chatErrorMessageClassNameFullScreen: S.chatErrorMessageClassNameFullScreen,
		buttonClassName: S.buttonClassName,
		chatHeaderButtonClassName: S.chatHeaderButtonClassName,
		chatHeaderButtonClassNameFloating: S.chatHeaderButtonClassNameFloating,
		chatHeaderButtonClassNameFullScreen: S.chatHeaderButtonClassNameFullScreen,
		chatHistoryClassName: S.chatHistoryClassName,
		chatHistoryClassNameFloating: S.chatHistoryClassNameFloating,
		chatHistoryClassNameFullScreen: S.chatHistoryClassNameFullScreen,
		chatHistoryItemClassName: S.chatHistoryItemClassName,
		chatHistoryItemClassNameFloating: S.chatHistoryItemClassNameFloating,
		chatHistoryItemClassNameFullScreen: S.chatHistoryItemClassNameFullScreen,
		chatHistorySectionClassName: S.chatHistorySectionClassName,
		chatHistorySectionClassNameFloating: S.chatHistorySectionClassNameFloating,
		chatHistorySectionClassNameFullScreen: S.chatHistorySectionClassNameFullScreen,
		textAreaClassName: S.textAreaClassName,
		textAreaClassNameFloating: S.textAreaClassNameFloating,
		textAreaClassNameFullScreen: S.textAreaClassNameFullScreen,
		formTextAreaClassName: S.formTextAreaClassName,
		formErrorClassName: S.formErrorClassName,
		modalClassName: S.modalClassName,
		modalHeaderClassName: S.modalHeaderClassName,
		chatCustomClassName: S.chatCustomClassName,
		chatFloatingCustomClassName: S.chatFloatingCustomClassName,
		chatFullscreenCustomClassName: S.chatFullscreenCustomClassName,
		chatHeaderCustomClassName: S.chatHeaderCustomClassName,
		chatHeaderCustomClassNameFloating: S.chatHeaderCustomClassNameFloating,
		chatHeaderCustomClassNameFullScreen: S.chatHeaderCustomClassNameFullScreen,
		chatMessagesCustomClassName: S.chatMessagesCustomClassName,
		chatMessagesCustomClassNameFloating: S.chatMessagesCustomClassNameFloating,
		chatMessagesCustomClassNameFullScreen: S.chatMessagesCustomClassNameFullScreen,
		chatAgentMessageCustomClassName: S.chatAgentMessageCustomClassName,
		chatAgentMessageCustomClassNameFloating: S.chatAgentMessageCustomClassNameFloating,
		chatAgentMessageCustomClassNameFullScreen: S.chatAgentMessageCustomClassNameFullScreen,
		chatUserMessageCustomClassName: S.chatUserMessageCustomClassName,
		chatUserMessageCustomClassNameFloating: S.chatUserMessageCustomClassNameFloating,
		chatUserMessageCustomClassNameFullScreen: S.chatUserMessageCustomClassNameFullScreen,
		chatInputCustomClassName: S.chatInputCustomClassName,
		chatInputCustomClassNameFloating: S.chatInputCustomClassNameFloating,
		chatInputCustomClassNameFullScreen: S.chatInputCustomClassNameFullScreen,
		chatErrorMessageCustomClassName: S.chatErrorMessageCustomClassName,
		chatHistoryCustomClassName: S.chatHistoryCustomClassName,
		chatHistoryCustomClassNameFloating: S.chatHistoryCustomClassNameFloating,
		chatHistoryCustomClassNameFullScreen: S.chatHistoryCustomClassNameFullScreen,
		chatUserVoiceMessageCustomClassName: S.chatUserVoiceMessageCustomClassName,
		chatUserVoiceMessageCustomClassNameFloating: S.chatUserVoiceMessageCustomClassNameFloating,
		chatUserVoiceMessageCustomClassNameFullScreen: S.chatUserVoiceMessageCustomClassNameFullScreen,
		chatVoiceInputCustomClassName: S.chatVoiceInputCustomClassName,
		chatVoiceInputCustomClassNameFloating: S.chatVoiceInputCustomClassNameFloating,
		chatVoiceInputCustomClassNameFullScreen: S.chatVoiceInputCustomClassNameFullScreen,
		chatErrorMessageCustomClassNameFloating: S.chatErrorMessageCustomClassNameFloating,
		chatErrorMessageCustomClassNameFullScreen: S.chatErrorMessageCustomClassNameFullScreen,
		chatSuggestedPromptsCustomClassName: S.chatSuggestedPromptsCustomClassName,
		chatSuggestedPromptsCustomClassNameFloating: S.chatSuggestedPromptsCustomClassNameFloating,
		chatSuggestedPromptsCustomClassNameFullScreen: S.chatSuggestedPromptsCustomClassNameFullScreen,
		fabCustomClassNameFloating: S.fabCustomClassNameFloating,
		fabCustomClassNameFullScreen: S.fabCustomClassNameFullScreen,
		fabNotificationCustomClassNameFloating: S.fabNotificationCustomClassNameFloating,
		fabNotificationCustomClassNameFullScreen: S.fabNotificationCustomClassNameFullScreen,
		popupPositionClassNameFloating: S.popupPositionClassNameFloating,
		popupPositionClassNameFullscreen: S.popupPositionClassNameFullscreen,
		helperTooltipClassName: S.helperTooltipClassName
	};
}
var $ = (e, t, n, r) => r === c.FLOATING ? t : r === c.FULLSCREEN ? n : e;
function Pt(e, t) {
	let n = t?.displayMode ?? c.FILL, r = $(e.chatHeaderClassName, e.chatHeaderClassNameFloating, e.chatHeaderClassNameFullScreen, n), i = $(e.chatMessagesClassName, e.chatMessagesClassNameFloating, e.chatMessagesClassNameFullScreen, n), a = $(e.chatInputAreaClassName, e.chatInputAreaClassNameFloating, e.chatInputAreaClassNameFullScreen, n), o = $(e.chatUserMessageClassName, e.chatUserMessageClassNameFloating, e.chatUserMessageClassNameFullScreen, n), s = $(e.chatAgentMessageClassName, e.chatAgentMessageClassNameFloating, e.chatAgentMessageClassNameFullScreen, n), l = $(e.chatErrorMessageClassName, e.chatErrorMessageClassNameFloating, e.chatErrorMessageClassNameFullScreen, n), u = $(e.chatUserVoiceMessageClassName, e.chatUserVoiceMessageClassNameFloating, e.chatUserVoiceMessageClassNameFullScreen, n), d = $(e.chatVoiceInputClassName, e.chatVoiceInputClassNameFloating, e.chatVoiceInputClassNameFullScreen, n), f = $(e.textAreaClassName, e.textAreaClassNameFloating, e.textAreaClassNameFullScreen, n), p = $(e.chatHeaderButtonClassName, e.chatHeaderButtonClassNameFloating, e.chatHeaderButtonClassNameFullScreen, n), m = $(e.chatHistoryClassName, e.chatHistoryClassNameFloating, e.chatHistoryClassNameFullScreen, n), h = $(e.chatHistoryCustomClassName, e.chatHistoryCustomClassNameFloating, e.chatHistoryCustomClassNameFullScreen, n), g = $(e.chatHistoryItemClassName, e.chatHistoryItemClassNameFloating, e.chatHistoryItemClassNameFullScreen, n), v = $(e.chatHistorySectionClassName, e.chatHistorySectionClassNameFloating, e.chatHistorySectionClassNameFullScreen, n), y = n === c.FLOATING ? "floating" : n === c.FULLSCREEN ? "fullscreen" : "fill", b = e.chatIconsByMode[n], x = [e.chatClassNamesByMode[n].chatInputFileAttachments, e.chatClassNamesByMode[n].chatInputFileItem].filter(Boolean).join(" ") || "", S = [...e.chatInputFileAttachmentsCustomStyles[y], ...e.chatInputFileItemCustomStyles[y]], C = [e.chatClassNamesByMode[n].chatUserFileAttachments, e.chatClassNamesByMode[n].chatUserFileItem].filter(Boolean).join(" ") || "", w = [...e.chatUserFileAttachmentsCustomStyles[y], ...e.chatUserFileItemCustomStyles[y]], T = e.chatClassNamesByMode[n].chatMessageActions ?? "", E = [e.chatClassNamesByMode[n].chatMessageFeedback, e.chatClassNamesByMode[n].chatMessageFeedbackReason].filter(Boolean).join(" ") || "", D = (() => {
		if (e.chatConfig.showAgentAvatar) return b.agentIcon ? {
			src: b.agentIcon,
			alt: "Chat agent icon"
		} : e.chatHeaderAvatar;
	})();
	return {
		messages: e.messages,
		reasoning: e.reasoning,
		showSuggestedPrompts: e.showSuggestedPrompts,
		agentSuggestions: e.agentSuggestions,
		hasMoreMessages: e.hasMoreMessages,
		loadingMore: e.loadingMore,
		onLoadMore: e.handleLoadMore,
		config: e.chatConfig,
		avatars: {
			header: e.chatHeaderAvatar,
			agent: D
		},
		icons: b,
		onSendMessage: e.handleSendMessage,
		onSendSuggestedPrompt: e.handleSendSuggestedPrompt,
		onSendConfiguredPrompt: e.handleSendConfiguredPrompt,
		onMessageCopied: e.chatAnalytics.messageCopied,
		onStopResponse: e.handleStopResponse,
		inputDisabled: e.inputDisabled,
		inputDisabledTooltip: e.inputDisabledTooltip,
		onNewChat: e.chatConfig.hideNewConversation ? void 0 : e.handleNewChat,
		onRegenerate: e.handleRegenerate,
		onVoiceMessage: e.handleVoiceMessage,
		showVoiceInput: e.chatInputFlowxProps?.voiceInputEnabled ?? !1,
		showFileUpload: e.fileUploadConfig.showFileUpload,
		fileAccept: e.fileUploadConfig.accept,
		fileMaxFiles: e.fileUploadConfig.maxFiles,
		fileMaxFilesSize: e.fileUploadConfig.maxFilesSize,
		fileInvalidTypeError: e.fileUploadConfig.invalidTypeError,
		fileCountExceededError: e.fileUploadConfig.countExceededError,
		fileSizeExceededError: e.fileUploadConfig.sizeExceededError,
		attachments: e.attachments,
		onAttachmentsChange: e.onAttachmentsChange,
		onAttachmentsMessage: e.handleAttachmentsMessage,
		attachmentsUploadError: e.attachmentsUploadError,
		attachmentsLabels: e.attachmentsLabels,
		attachmentsDataTestId: e.fileUploadConfig.dataTestId,
		fileItemDataTestId: e.fileUploadConfig.fileItemDataTestId,
		userAttachedFilesDataTestId: e.userAttachedFilesDataTestId,
		userFileItemDataTestId: e.userFileItemDataTestId,
		dataTestIds: e.dataTestIds,
		messageActionsConfig: e.messageActionsConfig,
		messageTimeGroupLabels: e.messageTimeGroupLabels,
		locale: _()?.locale,
		feedbackTarget: e.feedbackTarget,
		onFeedbackChange: (t, n) => e.handleFeedbackChange(t, n, e.messages.find((e) => e.messageId === t && e.sender === "receiver")?.feedback ?? null),
		onFeedbackSubmit: e.handleFeedbackSubmit,
		onFeedbackRemove: e.handleFeedbackRemove,
		onFeedbackCancel: e.handleFeedbackCancel,
		downloadFile: e.downloadAttachment,
		activeView: e.activeView,
		onHistory: e.chatConfig.hideHistory ? void 0 : e.handleOpenHistory,
		onBackFromHistory: e.handleCloseHistory,
		chatSessions: e.isSearchActive ? e.searchSessions : e.chatSessions,
		onSelectSession: e.handleSelectSession,
		onLoadMoreSessions: e.handleLoadMoreSessions,
		hasMoreSessions: !e.isSearchActive && e.hasMoreSessions,
		loadingMoreSessions: e.isSearchActive ? e.searchLoading : e.loadingMoreSessions,
		emptyStateText: e.isSearchActive ? e.searchLoading ? "" : e.conversationsNoResultsText : e.conversationsEmptyStateText,
		searchValue: e.searchText,
		onSearchChange: e.handleSearchChange,
		onSearchClear: e.handleSearchClear,
		searchPlaceholder: e.searchPlaceholder,
		searchClearAriaLabel: e.searchClearAriaLabel,
		searchHighlightText: e.searchHighlightText,
		sessionGroupLabels: e.sessionGroupLabels,
		headerTooltips: e.headerTooltips,
		voiceLabels: e.voiceLabels,
		headerControls: t?.headerControls,
		sendAriaLabel: j("@@sys_a11y_chat_submit_message"),
		sendTooltip: j("@@sys_chat_submit_message"),
		stopAriaLabel: j("@@sys_a11y_chat_cancel_request"),
		stopTooltip: j("@@sys_chat_cancel_request"),
		voiceMicAriaLabel: j("@@sys_a11y_chat_voice_input_record"),
		onToggleFullscreen: t?.onToggleFullscreen,
		isFullscreen: t?.isFullscreen,
		showFullscreenToggle: t?.showFullscreenToggle,
		onClose: t?.onClose,
		displayMode: y,
		headerActionIcons: e.headerActionIconsByMode[n],
		hideHeader: e.chatConfig.hideHeader,
		classNames: {
			header: r ?? "",
			headerCustom: $(e.chatHeaderCustomClassName, e.chatHeaderCustomClassNameFloating, e.chatHeaderCustomClassNameFullScreen, n) ?? [],
			headerConfig: e.chatHeaderConfigClassName ?? void 0,
			messages: i ?? "",
			messagesCustom: $(e.chatMessagesCustomClassName, e.chatMessagesCustomClassNameFloating, e.chatMessagesCustomClassNameFullScreen, n) ?? [],
			messagesConfig: e.chatMessagesConfigClassName ?? void 0,
			messageActions: T,
			messageActionsConfig: e.chatMessageActionsConfigClassName ?? void 0,
			messageFeedback: E,
			input: a ?? "",
			inputCustom: $(e.chatInputCustomClassName, e.chatInputCustomClassNameFloating, e.chatInputCustomClassNameFullScreen, n) ?? [],
			inputConfig: e.chatInputConfigClassName ?? void 0,
			userMessage: o ?? "",
			agentMessage: s ?? "",
			userMessageCustom: $(e.chatUserMessageCustomClassName, e.chatUserMessageCustomClassNameFloating, e.chatUserMessageCustomClassNameFullScreen, n) ?? [],
			agentMessageCustom: $(e.chatAgentMessageCustomClassName, e.chatAgentMessageCustomClassNameFloating, e.chatAgentMessageCustomClassNameFullScreen, n) ?? [],
			agentConfig: e.chatAgentConfigClassName ?? void 0,
			userConfig: e.chatUserConfigClassName ?? void 0,
			errorMessage: l ?? "",
			errorMessageCustom: $(e.chatErrorMessageCustomClassName, e.chatErrorMessageCustomClassNameFloating, e.chatErrorMessageCustomClassNameFullScreen, n) ?? [],
			userVoiceMessage: u ?? "",
			userVoiceMessageCustom: $(e.chatUserVoiceMessageCustomClassName, e.chatUserVoiceMessageCustomClassNameFloating, e.chatUserVoiceMessageCustomClassNameFullScreen, n) ?? [],
			voiceInput: d ?? "",
			voiceInputCustom: $(e.chatVoiceInputCustomClassName, e.chatVoiceInputCustomClassNameFloating, e.chatVoiceInputCustomClassNameFullScreen, n) ?? [],
			inputFileAttachments: x,
			inputFileAttachmentsCustom: S,
			userFileAttachments: C,
			userFileAttachmentsCustom: w,
			reasoning: s ?? "",
			suggestedPrompts: [
				K($(U.ChatSuggestedPrompts, U.ChatSuggestedPromptsFloating, U.ChatSuggestedPromptsFullScreen, n)),
				K($(U.ChatSuggestedPromptsSection, U.ChatSuggestedPromptsSectionFloating, U.ChatSuggestedPromptsSectionFullScreen, n)),
				K($(U.ChatSuggestedPromptsItem, U.ChatSuggestedPromptsItemFloating, U.ChatSuggestedPromptsItemFullScreen, n))
			].filter(Boolean).join(" ") || null,
			suggestedPromptsCustom: $(e.chatSuggestedPromptsCustomClassName, e.chatSuggestedPromptsCustomClassNameFloating, e.chatSuggestedPromptsCustomClassNameFullScreen, n) ?? [],
			helperTooltip: K(U.HelperTooltip),
			button: e.buttonClassName ?? "",
			headerButton: p ?? "",
			textArea: f ?? "",
			feedbackTextArea: e.formTextAreaClassName ?? "",
			feedbackError: e.formErrorClassName ?? "",
			feedbackModal: e.modalClassName ?? "",
			feedbackModalHeader: e.modalHeaderClassName ?? "",
			history: m ?? "",
			historyCustom: h ?? [],
			historyItem: g ?? "",
			historyItemTooltip: e.helperTooltipClassName ?? "",
			historySection: v ?? "",
			historySearch: e.chatClassNamesByMode[n].chatHistorySearch ?? "",
			headerTooltip: e.helperTooltipClassName ?? ""
		}
	};
}
//#endregion
//#region libs/sdk/react/src/components/ui-wrapper/chat/FlxChatWrapperFillMode.tsx
var Ft = (e) => {
	let { flowxUuid: t, className: n, chatClassName: r, chatCustomClassName: i, dataTestId: a, displayOptions: s } = e;
	pt({ isOpen: !0 });
	let c = z(null), l = (s?.style)?.fill?.heightType === "fill", d = o(c, l, [i.join(" ")]);
	return /* @__PURE__ */ J(Fe, {
		ref: c,
		"data-uniqueid": t,
		"data-flowx-component": u.CHAT,
		className: H(r, ...i, n),
		"data-testid": a,
		style: d ? { height: d } : void 0,
		children: /* @__PURE__ */ J(dt, { ...Pt(e) })
	});
}, It = ({ canToggleMode: e, initialFullscreen: t, initialOpen: n = !1 }) => {
	let [r, i] = B(n), [a, o] = B(t ? c.FULLSCREEN : c.FLOATING);
	L(() => {
		t && o(c.FULLSCREEN);
	}, [t]);
	let s = F(() => {
		o((e) => e === c.FLOATING ? c.FULLSCREEN : c.FLOATING);
	}, []), l = F(() => i(!1), []);
	return {
		isOpen: r,
		setIsOpen: i,
		currentMode: a,
		isFullscreen: a === c.FULLSCREEN,
		toggleMode: e ? s : void 0,
		closeChat: l
	};
}, Lt = (e) => R(() => {
	let t = K(U.ChatFabFloating), n = K(U.ChatFabFullScreen), r = K(U.ChatFabNotificationFloating), i = K(U.ChatFabNotificationFullScreen), a = K(U.Button), o = G(U.ChatFabFloating, "fabChatIcon"), s = G(U.ChatFabFullScreen, "fabChatIcon"), c = o ? E(o) : null, l = s ? E(s) : null;
	return {
		fabClassName: t,
		fabFullScreenClassName: n,
		fabNotificationClassName: r,
		fabNotificationFullScreenClassName: i,
		buttonClassName: a,
		fabIconPath: (e ? l : c) ?? null,
		fabIconFallbackName: e ? "caretDown" : "arrowUp"
	};
}, [e]), Rt = (e) => {
	let { flowxUuid: t, chatClassNameFloating: n, chatClassNameFullScreen: r, chatFloatingCustomClassName: i, chatFullscreenCustomClassName: a, fabCustomClassNameFloating: o, fabCustomClassNameFullScreen: s, fabNotificationCustomClassNameFloating: l, fabNotificationCustomClassNameFullScreen: d, popupPositionClassNameFloating: f, popupPositionClassNameFullscreen: p, canToggleMode: m, initialFullscreen: h = !1, initialOpen: g = !1, dataTestId: _, chatAnalytics: v } = e, y = It({
		canToggleMode: m,
		initialFullscreen: h,
		initialOpen: g
	}), b = Lt(y.isFullscreen), x = lt(), S = y.isFullscreen && x != null, C = y.isFullscreen ? r : n, w = y.isFullscreen ? s : o, T = y.isFullscreen ? d : l, E = pt({ isOpen: y.isOpen }), D = (e, t) => {
		if (!e && (t.reason === "outside-press" || t.reason === "focus-out")) {
			t.cancel();
			return;
		}
		e && !y.isOpen && v.chatOpened(), y.setIsOpen(e);
	}, ee = {
		onClose: y.closeChat,
		showFullscreenToggle: m,
		displayMode: y.isFullscreen ? c.FULLSCREEN : c.FLOATING,
		...m ? {
			onToggleFullscreen: y.toggleMode,
			isFullscreen: y.isFullscreen
		} : {}
	};
	return /* @__PURE__ */ Xe(Y.Root, {
		modal: y.isFullscreen,
		open: y.isOpen,
		onOpenChange: D,
		children: [/* @__PURE__ */ J(Y.Trigger, { render: /* @__PURE__ */ Xe("button", {
			type: "button",
			className: H("flx-chat-fab", "flx-chat-fab-fullscreen", b.buttonClassName, b.fabClassName, y.isFullscreen && b.fabFullScreenClassName, ...w),
			"data-testid": _ ? `${_}-fab` : "chat-fab",
			"data-uniqueid": t ? N(t, "launcher") : void 0,
			"data-flowx-component": u.CHAT,
			"aria-label": "Open chat",
			children: [b.fabIconPath ? /* @__PURE__ */ J(qe, { path: b.fabIconPath }) : /* @__PURE__ */ J(qe, { name: b.fabIconFallbackName }), E > 0 && !y.isOpen && /* @__PURE__ */ J("span", {
				className: H("flx-chat-fab-notification", y.isFullscreen && "flx-chat-fab-notification-fullscreen", b.fabNotificationClassName, y.isFullscreen && b.fabNotificationFullScreenClassName, ...T),
				children: E > 9 ? "9+" : E
			})]
		}) }), /* @__PURE__ */ Xe(Y.Portal, {
			container: x?.current,
			children: [y.isFullscreen && /* @__PURE__ */ J(Y.Backdrop, { className: H("flx-chat-backdrop", S && "flx-chat-backdrop-in-container") }), /* @__PURE__ */ J(Y.Positioner, {
				positionMethod: "fixed",
				className: H("flx-chat-positioner", y.isFullscreen ? "flx-chat-positioner-fullscreen" : "flx-chat-positioner-floating", S && "flx-chat-positioner-fullscreen-in-container", y.isFullscreen ? p : f),
				children: /* @__PURE__ */ J(Y.Popup, {
					className: H("flx-chat-popup", y.isFullscreen ? "flx-chat-popup-fullscreen" : "flx-chat-popup-floating", S && "flx-chat-popup-fullscreen-in-container", ...y.isFullscreen ? a : i),
					children: /* @__PURE__ */ J(Fe, {
						"data-uniqueid": t,
						"data-flowx-component": u.CHAT,
						className: H(C ?? ""),
						"data-testid": _,
						"data-fullscreen": y.isFullscreen,
						children: /* @__PURE__ */ J(dt, { ...Pt(e, ee) })
					})
				})
			})]
		})]
	});
}, zt = (e) => R(() => {
	let t = e?.displayTypes, n = t?.includes(c.FLOATING) ?? !1, r = t?.includes(c.FULLSCREEN) ?? !1;
	return {
		displayTypes: t,
		hasFloating: n,
		hasFullscreen: r,
		isFillMode: !t?.length || t.length === 1 && t[0] === c.FILL,
		canToggleMode: !!(n && r),
		initialFullscreen: r && !n
	};
}, [e?.displayTypes]), Bt = /* @__PURE__ */ it({
	FlxChatWrapper: () => Vt,
	default: () => Vt,
	defaultChatConfig: () => gt,
	useFlxChatWrapperState: () => Nt
}), Vt = ({ config: e, initialOpen: t }) => {
	let n = Nt(e), r = zt(n.flowxProps);
	return r.isFillMode ? /* @__PURE__ */ J(Ft, {
		...n,
		dataTestId: n.flowxProps?.dataTestId
	}) : /* @__PURE__ */ J(Rt, {
		...n,
		canToggleMode: r.canToggleMode,
		initialFullscreen: r.initialFullscreen,
		initialOpen: t,
		dataTestId: n.flowxProps?.dataTestId
	});
};
//#endregion
export { ut as a, rt as c, xt as i, it as l, Bt as n, ct as o, St as r, st as s, Vt as t, ot as u };
